module.exports = __webpack_public_path__ + "static/media/elements_section2_slide2.e3218db5.png";